import request from "../../../utils/wapRequest";
let domainApi = process.env.VUE_APP_WAP_API;
let url = process.env.VUE_APP_BASE_API_V2;
const BASE_URL_LOGIN = process.env.VUE_APP_BASE_LOGIN;

const TeeTimeResource = {
  detailTeeTime(query, data) {
    return request({
      url: `${domainApi}/get_tee_time_by_facility`,
      method: "POST",
      params: query,
      data
    });
  },

  searchGolfer(query, data) {
    return request({
      url: `${BASE_URL_LOGIN}/services/search_user`,
      method: "POST",
      params: query,
      data
    });
  },

  sendOTP(query, data) {
    return request({
      url: `${domainApi}/get_sms_otp_booking`,
      method: "POST",
      params: query,
      data
    });
  },

  confirmOTP(query, data) {
    return request({
      url: `${domainApi}/booking_pax_new`,
      method: "POST",
      params: query,
      data
    });
  },

  detailBooked(query, data) {
    return request({
      url: `${domainApi}/view_detail_order_slot_pax`,
      method: "POST",
      params: query,
      data
    });
  },

  historyBooked(query, data) {
    return request({
      url: `${domainApi}/get_history_booking_merge`,
      method: "POST",
      params: query,
      data
    });
  },

  createOrderBankWithCodeBooked(data) {
    return request({
      url: `${domainApi}/receive-bill-bank`,
      method: "POST",
      data
    });
  },

  renderAes256(data) {
    return request({
      url: `${domainApi}/aes256`,
      method: "POST",
      data
    });
  },

  renderAes256STB(data) {
    return request({
      url: `${domainApi}/aes256STB`,
      method: "POST",
      data
    });
  },
  encryptDataInquireBidv(data) {
    return request({
      url: `${domainApi}/encrypt_data_inquire_bidv`,
      method: "POST",
      data,
      headers: {
        "x-client-secret": "7f1383dd426ccc4827e55af803c5d956"
      }
    });
  }
};

export { TeeTimeResource as default };
